import { SyntheticEvent } from 'react';

export function detectScrollToBottom(event: SyntheticEvent<HTMLDivElement>) {
	const { scrollHeight, scrollTop, clientHeight } = event.currentTarget;
	return scrollHeight - scrollTop > clientHeight;
}

export const hexToRGBa = (hex: string, opacity: number) => {
	const hexToRGBA = hex.match(/[A-Za-z0-9]{2}/g)?.map((v) => parseInt(v, 16));
	const opp = opacity > 1 && opacity < 0 ? 1 : opacity;
	return `rgba(${hexToRGBA?.concat(opp).join()})`;
};
export const handleUserKeyPress = (e: KeyboardEvent, onEnter:()=>void) =>{
	const { keyCode } = e;
	if(keyCode===13){
		onEnter()
	}
}